<template>
	<div>
		<p v-if="$tera.project.TrialWizard.approval">
			{{ selectRandom(["The process for obtaining research ethics approval involves ","Plans to obtain research ethics approval include ", "Obtaining research ethics approval will require "]) }}
			{{ $tera.project.TrialWizard.approval }}
		</p>
		<p v-if="$tera.project.TrialWizard.protocol">
			{{ selectRandom(["Plans for amendments to the study protocol include ", "Amendments to the study protocol will planned as ","Plans for communicating important protocol modifications include "]) }}
			{{ $tera.project.TrialWizard.protocol }}
		</p>
		<p v-if="$tera.project.TrialWizard.responsiblePerson">
			{{ selectRandom(["Obtaining consent and/or assent was the responsibility of ", "The responsibility for obtaining consent and/or assent was given to ", "The duty to obtain consent and/or assent was entrusted to "]) }}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.responsiblePerson)
				)
			}}.
		</p>
		<p v-if="$tera.project.TrialWizard.consent">
			{{ selectRandom(["Consent and/or assent were obtained through ", "The process of obtaining consent and/or assent involved ", "Consent and/or assent were gathered through "]) }}
			{{ $tera.project.TrialWizard.consent }}
		</p>
		<p v-if="$tera.project.TrialWizard.confidentiality">
			{{ selectRandom(["Confidentiality and study blinding will be maintained through ","The study will ensure confidentiality and blinding through ","Confidentiality and study blinding will be safeguarded through "]) }}
			{{ $tera.project.TrialWizard.confidentiality }}
		</p>
		<p v-if="$tera.project.TrialWizard.declaration">
			{{ selectRandom(["The Declarations of interests include ", "The declarations of interests consist of associations with ", "Financial and other Competing Interests for principal investigators include "]) }}
			{{ $tera.project.TrialWizard.declaration }}
		</p>
		<p v-if="$tera.project.TrialWizard.access">
			{{ selectRandom(["Access to study data will be controlled through ", "Access to study data will be regulated through ", "The control of study data access will be managed through "]) }}
			{{ $tera.project.TrialWizard.access }}
		</p>
		<p v-if="$tera.project.TrialWizard.care">
			{{ selectRandom(["Ancillary and post-trial care will be arranged through ","Ancillary and post-trial care will be facilitated through ", "The arrangement for ancillary and post-trial care will be managed through "]) }}
			{{ $tera.project.TrialWizard.care }}
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputEthicsAndConsent",
	mixins: [OutputMixin]
};
</script>
